import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Notebook fetishism",
  "description": "",
  "published": "2011-10-27T00:00:00.000Z",
  "redirect_from": ["/blog/notebook-fetishism/swizec/2729"],
  "categories": "Apple, Blank Books, Moleskine, Notebooks and Laptops, Post-it note, Uncategorized, Vendors, Writers Resources",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/tumblr_ltq983kENF1qekjngo1_5001.jpg",
        "alt": null,
        "title": "Notebook :P"
      }}></img></p>
    <p>{`Ever since I was a wee lad I thought I might one day write an epic book that at least two people will read. I realize now it's difficult to write a book when you're coding all the time.`}</p>
    <p>{`The internet doesn't help either.`}</p>
    <p>{`However something good did come out of this obsession with writing - at some point in high school I realized it would be incredibly useful to always keep a notebook on hand to jot down any idea that might pop up at an unexpected time.`}</p>
    <p>{`And so the notebook fetishism began.`}</p>
    <p>{`My first pocket notebook looked more like a collection of post-it notes inside a cardboard case thing. Of course it proved unwieldy to keep in my pocket and needless to say it eventually broke down so much it seems I've thrown it out ... can't find it anywhere.`}</p>
    <p>{`Here's all the notebooks that survived through the years, ordered roughly in chronologically. The right-most three I'm using right now (the big one and two under it) ... ok, actually the totally rightmost one is still waiting to begin its career. There's also a fake moleskine in there; that first black notebook from the left.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/tumblr_ltq8eqTVOT1qekjngo1_50016.jpg",
        "alt": null,
        "title": "Notebooks!"
      }}></img></p>
    <p>{`It's taken me `}<em parentName="p">{`years`}</em>{` to discover the wonder that is `}<a parentName="p" {...{
        "href": "http://www.moleskine.com/",
        "title": "Moleskine"
      }}>{`Moleskine`}</a>{`. Now sure, some might say it's an overpriced notebook designed to take money away from hapless hipsters.`}</p>
    <p>{`But I think Moleskine is really the `}<a parentName="p" {...{
        "href": "http://www.apple.com",
        "title": "Apple"
      }}>{`Apple`}</a>{` of notebooks, which again will say to most people that it's an overpriced piece of kit designed to take money away from hapless hipsters. Their latest PR blunder aside, I have to say I really love these things - probably won't be buying any other brand in the foreseeable future.`}</p>
    <p>{`At least not for the ones I like to keep in my pocket. That big moleskine right there? Yeah, that was kind of stupid, sure I love it to bits, but `}<em parentName="p">{`17 euro`}</em>{` for a notebook with ~200 pages that for some reason isn't even hardcover? O.o`}</p>
    <p>{`Moleskine just seems to care more about details than most other notebooks I've tried. Where else does each notebook come with a tracking number and a note that should there be anything funky, you should just report `}<em parentName="p">{`that particular`}</em>{` notebook and the particular quality assurance person in charge of that particular notebook will be thwapped over the nose?`}</p>
    <p>{`I'm sure the marketing story coming with each notebook is bullshit, but it feels nice that they even care enough to include it.`}</p>
    <p>{`However, the ultimate test came when I started using the ultra skinny ones. You know, the one you can `}<em parentName="p">{`actually`}</em>{` keep in your backpocket at all times so you literally never find yourself without a notebook as long as you aren't naked.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/tumblr_ltq983kENF1qekjngo1_5006.jpg",
        "alt": null,
        "title": "Two months in a pocket"
      }}></img></p>
    <p>{`Kept it there, nice and cosy next to my arse, for two months every day. Sat on it, sweated on it when it was hot and I was in a hurry, did unspeakably horrible things to it ... nothing happened. Sure it looks battered and the covers are bent and crinkley. But not a single paper fell out, the stitching is still perfect ... the cover didn't even start layering!`}</p>
    <p>{`Any other notebook I've had felt like it was about to die after a week of staying in my pocket ... papers starting to fall out, the back breaking ... things like that.`}</p>
    <p>{`Anyone else a fan of notebooks that just work?`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.fabsugar.com/Notably-Cute-Notebooks-39487"
        }}>{`Notably Cute Notebooks`}</a>{` (fabsugar.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://nopenintended.wordpress.com/2011/10/15/mini-review-rhodia-5x5-grid-pad-no-10/"
        }}>{`Mini Review: Rhodia 5×5 Grid Pad No. 10`}</a>{` (nopenintended.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://practicalpages.wordpress.com/2011/10/12/a-little-house-notebook/"
        }}>{`A Little House Notebook`}</a>{` (practicalpages.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.newcommbiz.com/moleskine-alternatives-for-gtd-hacking/"
        }}>{`Moleskine Alternatives For GTD Hacking`}</a>{` (newcommbiz.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://r.zemanta.com/?u=http%3A//www.guardian.co.uk/books/booksblog/2011/jul/07/notebooks-euchtterm1917-moleskine&a=48111636&rid=dc5e50b1-edaa-44e7-973a-9d2ca31bb15a&e=baf2d7bbfdb45fbc4d8b138bbfe622d2"
        }}>{`Notes on notebooks`}</a>{` (guardian.co.uk)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=dc5e50b1-edaa-44e7-973a-9d2ca31bb15a",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      